import $http from '../../../axios-instance';
import Swal from 'sweetalert2';
import { controlErrorsCallback } from '../../../helpers/forms';
/**
 * Buscar Guías de respuestas de emergencias.
 *
 * @param {*} { commit }: store del módulo.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function search({ commit }, param) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`nu-gres/emergency-response/guides?param=${param}`)
        .then(({ data: response }) => commit('setEmergencyResponseGuides', response.data))
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Guías de respuestas de emergencias',
                text: 'Falla al tratar de cargar las Guías de respuestas de emergencias.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Crear detalles de las guías de respuestas a emergencias.
 *
 * @param {*} { commit }: store del módulo.
 * @param payload: información para guardar.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function store({ commit, dispatch, state }, payload) {
    commit('dashboard/load', true, { root: true });

    await $http.post('nu-gres/emergency-response/guides/details', payload)
        .then(({ data: response }) => {

            // Se crea desde el Home y se requiere recargar las guías
            if (state.useSelectNuGreInFrom) {
                dispatch('getEmergencyResponseGuides', {
                    page: 1,
                    per_page: 10
                })
            }
            // Se crea desde el detalle de una guía y se require recargar sus detalles
            else {
                dispatch('getDetailsByEmergencyResponseGuide', {
                    id: payload.slq_emergency_response_guide_id,
                    page: 1,
                    per_page: 10
                })
            }

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Detalles de las guías de respuestas a emergencias',
                text: response.message,
                showConfirmButton: true,
            })

            commit('resetDetailsNuGres');
            commit('setAction', 'CREATE');

        })
        .catch(errors => {

            // Errores de validaciones
            if (controlErrorsCallback(errors)) return false;

            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Detalles de las guías de respuestas a emergencias',
                text: 'Falla al tratar de crear los detalles de las guías de respuestas a emergencias.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}


/**
 * Actualizar detalles de las guías de respuestas a emergencias.
 *
 * @param {*} { commit }: store del módulo.
 * @param payload: información para guardar.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function update({ commit, dispatch }, payload) {
    commit('dashboard/load', true, { root: true });

    await $http.put(`nu-gres/emergency-response/guides/details/${payload.id}`, payload)
        .then(({ data: response }) => {

            dispatch('getDetailsByEmergencyResponseGuide', {
                id: payload.slq_emergency_response_guide_id,
                page: 1,
                per_page: 10
            })

            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Detalles de las guías de respuestas a emergencias',
                text: response.message,
                showConfirmButton: true,
            })

            commit('resetDetailsNuGres');
            commit('setAction', 'CREATE');

        })
        .catch(errors => {

            // Errores de validaciones
            if (controlErrorsCallback(errors)) return false;

            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Detalles de las guías de respuestas a emergencias',
                text: 'Falla al tratar de actualizar el detalle de la guía de respuestas a emergencias.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Cargar las guías de respuestas a emergencias.
 *
 * @param {*} { commit, state }: store del módulo.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function getEmergencyResponseGuides({ commit, state }, payload) {
    commit('dashboard/load', true, { root: true });

    if (!payload) payload = state.tableConfig.dataFieldsDetails;

    await $http.get(`nu-gres/emergency-response/guides/all?page=${payload.page}&per_page=${payload.per_page}`)
        .then(({ data: response }) => {

            commit('setResponseGuidesOfEmergencies', response.data);
            commit('setTableConfigPaginationNuGre', {
                page: payload.page,
                total: response.data.total,
                current_page: response.data.current_page,
                per_page: payload.per_page
            });

        })
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Detalles de las guías de respuestas a emergencias',
                text: 'Falla al tratar de cargar los detalles de las guías de respuestas a emergencias.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Cargar los detalles de las guías de respuestas a emergencias.
 *
 * @param {*} { commit, state }: store del módulo.
 * @returns {Promise<boolean>}
 * @author Fernando Claros
 */
export async function getDetailsByEmergencyResponseGuide({ commit, state }, payload) {
    commit('dashboard/load', true, { root: true });

    if (!payload) payload = state.tableConfig.dataFields;

    await $http.get(`nu-gres/emergency-response/guides/details/${payload.id}?page=${payload.page}&per_page=${payload.per_page}`)
        .then(({ data: response }) => {
            
            commit('setDetailsOfGuide', response.data);
            commit('setTableConfigPaginationGuidesDetails', {
                page: payload.page,
                total: response.data.total,
                current_page: response.data.current_page,
                per_page: payload.per_page
            });

        })
        .catch(() => {
            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Detalles de las guías de respuestas a emergencias',
                text: 'Falla al tratar de cargar los detalles de las guías de respuestas a emergencias.',
                showConfirmButton: true,
            })

        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}